import { useParams } from 'react-router-dom';

function useUrlParam(
  name: string,
  opts?: { int: false; onParseError?: () => void }
): string;
function useUrlParam(
  name: string,
  opts?: { int: true; onParseError?: () => void }
): number;
function useUrlParam(
  name: string,
  opts?: { int: boolean; onParseError?: () => void }
): string | number; 
function useUrlParam<const T extends string>(
  name: T,
  opts?: { int?: boolean; onParseError?: () => void }
): string | number {
  const params = useParams<{ [key in T]: string }>();
  const int = opts?.int ?? false;
  const value_ = params[name];
  if (int) {
    const parsed = Number.parseInt(value_);
    if (isNaN(parsed)) {
      opts?.onParseError?.();
    }
    return parsed;
  }
  return value_;
}

export default useUrlParam;
